export default __webpack_public_path__ + "static/media/banner-bg-image.6ef3fc2e.png";